import React from 'react';
import { Users, Target, CheckCircle, TrendingUp } from 'lucide-react';

const metrics = [
  {
    title: 'Win Rate Analysis',
    value: '68%',
    change: '+4.2%',
    description: 'Success rate in competitive bids',
    icon: Target,
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600',
  },
  {
    title: 'Team Utilization',
    value: '85%',
    change: '+2.8%',
    description: 'Resource allocation efficiency',
    icon: Users,
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-600',
  },
  {
    title: 'Proposal Quality',
    value: '94%',
    change: '+1.5%',
    description: 'Compliance score average',
    icon: CheckCircle,
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600',
  },
  {
    title: 'Revenue Growth',
    value: '$12.4M',
    change: '+15.3%',
    description: 'Year-over-year contract value',
    icon: TrendingUp,
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600',
  },
];

export function PerformanceInsights() {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h2 className="text-lg font-medium text-gray-900">Performance Insights</h2>
      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
        {metrics.map((metric) => {
          const Icon = metric.icon;
          return (
            <div key={metric.title} className="relative overflow-hidden rounded-lg border border-gray-200 bg-white p-4">
              <div className="flex items-center">
                <div className={`rounded-lg ${metric.iconBg} p-3`}>
                  <Icon className={`h-6 w-6 ${metric.iconColor}`} />
                </div>
                <div className="ml-4 flex-1">
                  <h3 className="text-sm font-medium text-gray-500">{metric.title}</h3>
                  <div className="mt-1">
                    <p className="text-2xl font-semibold text-gray-900">{metric.value}</p>
                    <p className="flex items-baseline">
                      <span className="text-sm font-semibold text-green-600">{metric.change}</span>
                      <span className="ml-2 text-sm text-gray-500">{metric.description}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}